window.addEventListener('load', (event) => {
    $(".main-blog__categoryDropdown").on('click touch', function(){
        var minus = $(".icon-minus");
        var plus = $(".icon-plus");
        document.getElementById("categoryDrop").classList.toggle("show");
        if(document.getElementById("categoryDrop").classList.contains('show')){
            plus.hide();
            minus.show();
        } else{
            plus.show();
            minus.hide();
        }
    })
    window.onclick = function(event) {
        if (!event.target.matches('.categoryDropbtn')) {
            $(".icon-plus").show();
            $(".icon-minus").hide();
            var dropdowns = document.getElementsByClassName("dropdown-content");
            var i;
            for (i = 0; i < dropdowns.length; i++) {
                var openDropdown = dropdowns[i];
                if (openDropdown.classList.contains('show')) {
                    openDropdown.classList.remove('show');
                }
            }
        }
    }

    function loadMore() {
        let moreButton = $('#showMore');
        let nextUrl = $(moreButton).attr("data-link");
            triggered = true;
        // Make ajax call to next page for load more data
        $.ajax({
            url: nextUrl,
            type: 'GET',
            beforeSend: function() {
                moreButton.toggleClass("button--loading")
                moreButton.css("background-color", "#999289");
            }
        })
        .done(function(data) {
            // Append data
            $('.main-blog__article-sorted-grid').append($(data).find('.main-blog__article-sorted-grid').html());
            moreButton.toggleClass("button--loading")
            moreButton.css("background-color", "#fff");
            var newUrl = $(data).find('#showMore').attr("data-link");
            if ( newUrl != undefined ){
                moreButton.attr("data-link", newUrl);
            } else{
                moreButton.hide();
            }
        });
    }

    const showMoreBtn = document.getElementById("showMore");
    if(showMoreBtn){
        document.getElementById("showMore").addEventListener("click", loadMore);
    }
})